import pick from 'object.pick';
import {stringify} from 'qs';

import {get} from '@stubhub/rest-method';

import SearchInventoryV2Interface from './interface';

const LISTING_PATH = '/search/inventory/v2/listings';
const SEARCH_DEFAULT_TIMEOUT = 10000;

const defaults = {
  additionalPricingInfo: false,
  allSectionZoneStats: false,
  edgeControlEnabled: true,
  eventLevelStats: false,
  eventPricingSummary: true,
  listingAttributeCategorySummary: false,
  pricingSummary: true,
  quantitySummary: false,
  sectionStats: true,
  shstore: 1,
  start: 0,
  valuePercentage: false,
  zoneStats: false,
  scoreVersion: 'v2',
};

function getPriceType(search) {
  if (search.priceType) {
    return search.priceType;
  }

  return search.priceWithFees ? 'bundledPrice' : 'nonBundledPrice';
}

function getInventoryListingUrl(search, opts) {
  const queryParams = {
    ...getBaseQueryParams(opts),
    ...search,
    priceType: getPriceType(search),
  };

  return `${LISTING_PATH}?${stringify(queryParams)}`;
}

function getBaseQueryParams(opts) {
  return {
    ...defaults,
    ...pick(opts, Object.keys(defaults)),
  };
}

export default function SearchInventoryV2(opts = {}) {
  return {
    get: async ({headers: requestHeaders, cookies, ...args}) => {
      const headers = {
        'Accept-Language': opts.lang || 'en-US',
        ...requestHeaders,
      };
      if (!__CLIENT__) {
        // We want to add the SH_UT cookie to the headers if we are on the server. If it's not present, we will fallback to the Authorization header
        const shUT = cookies.get('SH_UT');
        if (shUT) {
          headers.Cookie = `SH_UT=${shUT}`;
        } else {
          headers.Authorization = process.env.REACT_APP_API_SECRET;
        }
      }

      const defaults = {
        host: process.env.REACT_APP_API_HOST,
        path: getInventoryListingUrl(args, opts),
        headers,
        json: true,
        timeout: opts.timeout || SEARCH_DEFAULT_TIMEOUT, // Setting to max timeout 10 seconds
      };

      const resultingConfig = {...defaults, ...args};

      return await get(resultingConfig).then(SearchInventoryV2Interface);
    },
  };
}
